/** Shared browser/server limits. Keep this module independent of the Help catalogue. */
export const HELP_CHAT_MAX_MESSAGES = 12;
export const HELP_CHAT_MAX_MESSAGE_LENGTH = 800;
